import dayjs from 'dayjs';

import { CalendarConfig } from 'src/services/config';
import { MetricType, DashboardSetting } from 'src/services/dashboard';

import { FrequencyType } from 'src/types/common';
import { SearchObjective } from 'src/types/objective';

import { getSequenceByDate } from './date';

export const getMetricSequenceScope = (
  metricType: MetricType,
  frequencyType: FrequencyType,
  currentSequence: number
) => {
  switch (metricType) {
    case MetricType.KPI:
      return [currentSequence];
    case MetricType.KPI_SUM:
      return getSequencesUntil(currentSequence);
    default:
      return [currentSequence];
  }
};

export const getSequencesUntil = (sequence: number) =>
  Array.from({ length: sequence }, (_, i) => i + 1);

export const getSearchObjective = (
  departmentId: string,
  rows: DashboardSetting[],
  date: dayjs.Dayjs,
  calendarConfig: CalendarConfig
): SearchObjective => {
  const sequences = new Set<number>();
  const frequencyTypes = new Set<FrequencyType>();
  const departmentIds = new Set<string>();
  const startYears = new Set<number>();
  const subjectIds = new Set<string>();
  departmentIds.add(departmentId);
  startYears.add(date.year());
  // eslint-disable-next-line no-restricted-syntax
  for (const row of rows) {
    // eslint-disable-next-line no-restricted-syntax
    for (const setting of rows) {
      const currentSequence = getSequenceByDate(date, setting.frequencyType, calendarConfig);
      if (setting.type === MetricType.KPI) {
        subjectIds.add(setting.subjectId);
      }
      getMetricSequenceScope(setting.type, setting.frequencyType, currentSequence).forEach((n) =>
        sequences.add(n)
      );
      frequencyTypes.add(setting.frequencyType);
    }
  }
  return {
    sequences: Array.from(sequences),
    frequencyTypes: Array.from(frequencyTypes),
    startYears: Array.from(startYears),
    departmentIds: Array.from(departmentIds),
    subjectIds: Array.from(subjectIds),
  };
};
